import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { QueryRequest } from '@models/index.model';

if (environment.production) {
  enableProdMode();
}

async function preLoadSpConfig() {
  const DEFAULT_GRAPH_SCOPES = environment.scopes;
  const res = await fetch(environment.apiUrl + QueryRequest.spConfig);
  const json = await res.json().catch(() => null);
  const settings = json?.data ?? null;
  if (settings && typeof settings === 'object') {
    (settings as any).sharepoint_scopes = DEFAULT_GRAPH_SCOPES;
  }
  // Si no hay config, la app debe seguir funcionando sin SharePoint
  if (settings?.sharepoint_clientid && settings?.sharepoint_tenantid) {
    localStorage.setItem('spConfigRuntime', JSON.stringify(settings));
  } else {
    localStorage.removeItem('spConfigRuntime');
  }
}

preLoadSpConfig()
  .catch(err => {
    console.error(err);
    localStorage.removeItem('spConfigRuntime');
  }).finally(() => platformBrowserDynamic().bootstrapModule(AppModule));
